/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react'
import { jsx } from "@emotion/core";
import { Modal } from 'react-bootstrap'
import TaskSearchInput from '../../../Components/common/TaskSearchInput';

function TaskSearchModal({ onHide, show = true }) {

    return (
        <Modal show={show} onHide={onHide} className="task-search-modal !rounded-25">
            <Modal.Body className="modal-body-extra-padding">
                <div className="full-model md-model-updates block">
                    <div className="full-model-body">
                        <div className="body-data">
                            <div id="task-search-input-wrapper">
                                <TaskSearchInput autoFocus={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default TaskSearchModal